import { TextDataResponseDTO } from '../../services/interfaces/apiInterfaces';

export class LabelGrids {
  title: string;
  show: string;
  entries: string;
  search: TextDataResponseDTO;
  tableCode: string;
  column1: string;
  column2: string;
  column3: string;
  column4: string;
  column5: string;
  column6: string;
  column7: string;
  column8: string;
  column9: string;
  column10: string;
  actions: string;
  paginationOf: string;
  columnAmount: string;
}
